// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactAssetNavigation_WFhTE {
  display: flex;
  flex-direction: column;
  gap: 12px;
  scroll-behavior: smooth;

  .deleteContact_DJpaD {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    color: var(--dc3545-background);
    gap: 7px;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 16.9px;
    cursor: pointer;

    .icon_o2qqF {
      display: flex;
      padding: 5px;
      align-items: center;
      gap: 10px;
      border-radius: 200px;
      background: var(--ed-background);
    }
  }

  .parameters_RPG0v {
    display: flex;
    gap: 10px;
    align-items: center;
    cursor: pointer;
    color: var(--black-color);
    pointer-events: auto;
    svg {
      width: 13px;
      height: 13px;
    }
  }
  .searchIconsWrappers_sK03y {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    background: var(--ececf1-background);
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    border-radius: 3px;
  }
  .parametersContainer_FD9oV {
    min-height: fit-content;
    transition: all 300ms;
    -webkit-transition: all 300ms;
    -moz-transition: all 300ms;
    -ms-transition: all 300ms;
    -o-transition: all 300ms;
    overflow: hidden;
    interpolate-size: allow-keywords;
    display: flex;
    flex-direction: column;
    gap: 20px;
    pointer-events: auto;
    ul {
      li {
        text-decoration: none;
        color: var(--_3-color);
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        .infoParameterItem_mdYPj{
          display: flex;
          align-items: center;
        }
      }
    }
  }
  ul {
    padding: 0;
    margin: 0;
    .active_BYTaD {
      border-left: 4px solid var(--_10a37f-background);
      border-radius: 10px;
      background-color: var(--ececf1-background);
      a {
        color: var(--_10a37f-background);
        font-weight: bold;
      }
    }
    li {
      list-style: none;
      height: 30px;
      display: flex;
      align-items: center;
      padding: 5px;

      a {
        text-decoration: none;
        color: var(--_3-color);
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
      }
    }
  }
}
.icon_o2qqF {
  right: 10px;
  cursor: pointer;
  opacity: 1; 
}

.visible_WBNgZ {
  opacity: 1;
}

.eye_UpznU {
  margin-left: 10px;
  width: 20px;
  height: 20px;
}
.btnContactInfoContainer_XV_Vj{
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
  justify-content: center;
  pointer-events: auto;
  button{
    border-radius: 999px;
    svg{
      color: var(--969595-fill);
      fill: var(--969595-fill);
    }
    .activeBtn_HsOgm{
      color: var(--_10a37f-border);
      fill: var(--_10a37f-border);
    }
  }
  svg{
    width: 20px;
    height: 20px;
  }
}

.dataInfo_M43v3{
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  pointer-events: auto;
  p{
    margin: 0px;
    color: #000000;
  }
  span{
    color: var(--_71-color);
  }
}

.tagsContainer_Xf1jx{
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: auto;

  .tag_s_57Y{
    display: flex;
    align-items: center;
    gap: 10px;
    span{
      width: 100%;
      padding: 10px 20px;
      border-radius: 10px;
    }
  }
}

.addParameterColumn_RdAtY{
  min-width: 20px;
  height: 20px;
     font-size: 16px;
     background-color: #ECECF1;
     display: flex;
     align-items: center;
     justify-content: center;
     border-radius: 999px;
     cursor: pointer;
}

.buttonsForSeeContainer_vF6UF{
  display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
    pointer-events: auto;

  .buttonForSee_ZWvd5{
    width: 100%;
    border: none;
    border-radius: 8px;
    background: #EAEAEA;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #6E6E80;
    padding: 10px;
    cursor:pointer
  }
}

.displayList_bnwNJ{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.lessCategoryContainer_tK8uB{
  display: flex;
    align-items: center;
    margin-left: -10px;
    padding: 15px 0px;
}
.lessCategory_Ef4KQ{
display: flex;
    align-items: center;
    gap: 5px;

    span{
      color: #10a37f;
    }
}
.textAndDragContainer_mzNzH{
   display: flex;
    align-items: center;
    padding: 5px 0px;
}
.textContainer_lTpJr{
  display:flex;
  align-items: center;
    gap: 10px;

  .text_i6UxV{
    display: flex;
    flex-direction: column;
    .span1_MgwLm{
      color: var(--black-color);
    }
    .span2_YZApr{
      color: #8E8E93;
    }
  }
}


.expandableContainer_uEGbm {
    width: 100%;
  overflow: hidden;
  transition: max-height 1s ease; /* Animación suave si querés */
   max-height: 0px; /* Comienza colapsado */
   pointer-events: auto;

  ul{
    padding: 0;
    margin: 0;
    list-style: none;
  }
}

.searchOpen_anpfW {
  max-height: 500px; /* Estimación suficientemente grande */
  overflow: visible; /* Permite que el contenido se muestre */
}

.iconParameter_bj_DV{
  width: 20px;
  height: 20px;
  fill: var(--_3-color);
  color: var(--_3-color);
}

.textParameter_XfFha{
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--_3-color);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NavigationPopups/ContactAssetNavigation/ContactAssetNavigation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;;EAEvB;IACE,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;;IAEf;MACE,aAAa;MACb,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,oBAAoB;MACpB,gCAAgC;IAClC;EACF;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB;MACE,WAAW;MACX,YAAY;IACd;EACF;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;IACxB,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oBAAoB;IACpB;MACE;QACE,qBAAqB;QACrB,sBAAsB;QACtB,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,sBAAsB;QACtB;UACE,aAAa;UACb,mBAAmB;QACrB;MACF;IACF;EACF;EACA;IACE,UAAU;IACV,SAAS;IACT;MACE,gDAAgD;MAChD,mBAAmB;MACnB,0CAA0C;MAC1C;QACE,gCAAgC;QAChC,iBAAiB;MACnB;IACF;IACA;MACE,gBAAgB;MAChB,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,YAAY;;MAEZ;QACE,qBAAqB;QACrB,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;MACrB;IACF;EACF;AACF;AACA;EACE,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB;IACE,oBAAoB;IACpB;MACE,yBAAyB;MACzB,wBAAwB;IAC1B;IACA;MACE,4BAA4B;MAC5B,2BAA2B;IAC7B;EACF;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;;EAEpB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT;MACE,WAAW;MACX,kBAAkB;MAClB,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,eAAe;EACf,YAAY;KACT,eAAe;KACf,yBAAyB;KACzB,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,oBAAoB;KACpB,eAAe;AACpB;;AAEA;EACE,aAAa;IACX,sBAAsB;IACtB,WAAW;IACX,QAAQ;IACR,oBAAoB;;EAEtB;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,aAAa;IACb;EACF;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;IACX,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;AACA,aAAa;IACT,mBAAmB;IACnB,QAAQ;;IAER;MACE,cAAc;IAChB;AACJ;AACA;GACG,aAAa;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;AACA;EACE,YAAY;EACZ,mBAAmB;IACjB,SAAS;;EAEX;IACE,aAAa;IACb,sBAAsB;IACtB;MACE,yBAAyB;IAC3B;IACA;MACE,cAAc;IAChB;EACF;AACF;;;AAGA;IACI,WAAW;EACb,gBAAgB;EAChB,8BAA8B,EAAE,8BAA8B;GAC7D,eAAe,EAAE,uBAAuB;GACxC,oBAAoB;;EAErB;IACE,UAAU;IACV,SAAS;IACT,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB,EAAE,sCAAsC;EACzD,iBAAiB,EAAE,wCAAwC;AAC7D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".ContactAssetNavigation {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  scroll-behavior: smooth;\n\n  .deleteContact {\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    color: var(--dc3545-background);\n    gap: 7px;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 16.9px;\n    cursor: pointer;\n\n    .icon {\n      display: flex;\n      padding: 5px;\n      align-items: center;\n      gap: 10px;\n      border-radius: 200px;\n      background: var(--ed-background);\n    }\n  }\n\n  .parameters {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    cursor: pointer;\n    color: var(--black-color);\n    pointer-events: auto;\n    svg {\n      width: 13px;\n      height: 13px;\n    }\n  }\n  .searchIconsWrappers {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    background: var(--ececf1-background);\n    cursor: pointer;\n    user-select: none;\n    border-radius: 3px;\n  }\n  .parametersContainer {\n    min-height: fit-content;\n    transition: all 300ms;\n    -webkit-transition: all 300ms;\n    -moz-transition: all 300ms;\n    -ms-transition: all 300ms;\n    -o-transition: all 300ms;\n    overflow: hidden;\n    interpolate-size: allow-keywords;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    pointer-events: auto;\n    ul {\n      li {\n        text-decoration: none;\n        color: var(--_3-color);\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        box-sizing: border-box;\n        .infoParameterItem{\n          display: flex;\n          align-items: center;\n        }\n      }\n    }\n  }\n  ul {\n    padding: 0;\n    margin: 0;\n    .active {\n      border-left: 4px solid var(--_10a37f-background);\n      border-radius: 10px;\n      background-color: var(--ececf1-background);\n      a {\n        color: var(--_10a37f-background);\n        font-weight: bold;\n      }\n    }\n    li {\n      list-style: none;\n      height: 30px;\n      display: flex;\n      align-items: center;\n      padding: 5px;\n\n      a {\n        text-decoration: none;\n        color: var(--_3-color);\n        width: 100%;\n        height: 100%;\n        display: flex;\n        align-items: center;\n      }\n    }\n  }\n}\n.icon {\n  right: 10px;\n  cursor: pointer;\n  opacity: 1; \n}\n\n.visible {\n  opacity: 1;\n}\n\n.eye {\n  margin-left: 10px;\n  width: 20px;\n  height: 20px;\n}\n.btnContactInfoContainer{\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  width: 100%;\n  justify-content: center;\n  pointer-events: auto;\n  button{\n    border-radius: 999px;\n    svg{\n      color: var(--969595-fill);\n      fill: var(--969595-fill);\n    }\n    .activeBtn{\n      color: var(--_10a37f-border);\n      fill: var(--_10a37f-border);\n    }\n  }\n  svg{\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.dataInfo{\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: center;\n  pointer-events: auto;\n  p{\n    margin: 0px;\n    color: #000000;\n  }\n  span{\n    color: var(--_71-color);\n  }\n}\n\n.tagsContainer{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  pointer-events: auto;\n\n  .tag{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    span{\n      width: 100%;\n      padding: 10px 20px;\n      border-radius: 10px;\n    }\n  }\n}\n\n.addParameterColumn{\n  min-width: 20px;\n  height: 20px;\n     font-size: 16px;\n     background-color: #ECECF1;\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     border-radius: 999px;\n     cursor: pointer;\n}\n\n.buttonsForSeeContainer{\n  display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 8px;\n    pointer-events: auto;\n\n  .buttonForSee{\n    width: 100%;\n    border: none;\n    border-radius: 8px;\n    background: #EAEAEA;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    color: #6E6E80;\n    padding: 10px;\n    cursor:pointer\n  }\n}\n\n.displayList{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.lessCategoryContainer{\n  display: flex;\n    align-items: center;\n    margin-left: -10px;\n    padding: 15px 0px;\n}\n.lessCategory{\ndisplay: flex;\n    align-items: center;\n    gap: 5px;\n\n    span{\n      color: #10a37f;\n    }\n}\n.textAndDragContainer{\n   display: flex;\n    align-items: center;\n    padding: 5px 0px;\n}\n.textContainer{\n  display:flex;\n  align-items: center;\n    gap: 10px;\n\n  .text{\n    display: flex;\n    flex-direction: column;\n    .span1{\n      color: var(--black-color);\n    }\n    .span2{\n      color: #8E8E93;\n    }\n  }\n}\n\n\n.expandableContainer {\n    width: 100%;\n  overflow: hidden;\n  transition: max-height 1s ease; /* Animación suave si querés */\n   max-height: 0px; /* Comienza colapsado */\n   pointer-events: auto;\n\n  ul{\n    padding: 0;\n    margin: 0;\n    list-style: none;\n  }\n}\n\n.searchOpen {\n  max-height: 500px; /* Estimación suficientemente grande */\n  overflow: visible; /* Permite que el contenido se muestre */\n}\n\n.iconParameter{\n  width: 20px;\n  height: 20px;\n  fill: var(--_3-color);\n  color: var(--_3-color);\n}\n\n.textParameter{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--_3-color);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ContactAssetNavigation": `ContactAssetNavigation_WFhTE`,
	"deleteContact": `deleteContact_DJpaD`,
	"icon": `icon_o2qqF`,
	"parameters": `parameters_RPG0v`,
	"searchIconsWrappers": `searchIconsWrappers_sK03y`,
	"parametersContainer": `parametersContainer_FD9oV`,
	"infoParameterItem": `infoParameterItem_mdYPj`,
	"active": `active_BYTaD`,
	"visible": `visible_WBNgZ`,
	"eye": `eye_UpznU`,
	"btnContactInfoContainer": `btnContactInfoContainer_XV_Vj`,
	"activeBtn": `activeBtn_HsOgm`,
	"dataInfo": `dataInfo_M43v3`,
	"tagsContainer": `tagsContainer_Xf1jx`,
	"tag": `tag_s_57Y`,
	"addParameterColumn": `addParameterColumn_RdAtY`,
	"buttonsForSeeContainer": `buttonsForSeeContainer_vF6UF`,
	"buttonForSee": `buttonForSee_ZWvd5`,
	"displayList": `displayList_bnwNJ`,
	"lessCategoryContainer": `lessCategoryContainer_tK8uB`,
	"lessCategory": `lessCategory_Ef4KQ`,
	"textAndDragContainer": `textAndDragContainer_mzNzH`,
	"textContainer": `textContainer_lTpJr`,
	"text": `text_i6UxV`,
	"span1": `span1_MgwLm`,
	"span2": `span2_YZApr`,
	"expandableContainer": `expandableContainer_uEGbm`,
	"searchOpen": `searchOpen_anpfW`,
	"iconParameter": `iconParameter_bj_DV`,
	"textParameter": `textParameter_XfFha`
};
export default ___CSS_LOADER_EXPORT___;
